import React from "react";
import "./WhatsAppButton.css";

export default function WhatsAppButton() {
  const phoneNumber = "+917736111482"; // 👈 Use country code (no +)
  const message = "Hello, I would like to know more about your Ayurvedic treatments.";

  const whatsappUrl = `https://wa.me/${phoneNumber}?text=${encodeURIComponent(message)}`;

  return (
    <a
      href={whatsappUrl}
      className="whatsapp-float"
      target="_blank"
      rel="noopener noreferrer"
    >
      <i className="bi bi-whatsapp"></i>
    </a>
  );
}
